import './stickers.css';

// Screenshots
import Screen from '../../assets/stickers/imessage.webp';

const Stickers = () => {
    return (
        <section id='stickers'> 
        <div className='container quizcut__container_top'>
        <div className='grid__container'>
          <div className='grid__container_left'>
            <h1 className='noselect'>Sticker packs for iMessage</h1>
            <p className='noselect'>
              A compact portfolio of iMessage sticker extensions: practical stamp-style sets (EN/RU) and a minimal Duckster for lighter replies. Each pack installs as a Messages app and is tuned to stay sharp at small sizes.
            </p>
            <p className='noselect'>
              <strong>Privacy Policy Agreement:</strong> Sticker packs can't collect data, so I don't collect any personal data about you and I don't store any personal data about you. Payments are processed and purchases fulfilled by the App Store.
            </p>
          </div>
            <div className='grid__container__icon'>
              <img className='sticker__icon' src={Screen} alt="iMessage sticker pack preview showing various stickers" />
            </div>
         </div>
        </div>
        </section>
    )
}

export default Stickers
